module.exports = __webpack_public_path__ + "img/011.c277aaed.jpg";